export const LeftArrow = () => {
  return (
    <svg
      width="0.4vw"
      height="0.7vw"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.47145 8.52843C5.7318 8.78878 5.7318 9.21089 5.47145 9.47124C5.2111 9.73159 4.78899 9.73159 4.52864 9.47124L0.528637 5.47124C0.276251 5.21886 0.267421 4.81246 0.508606 4.54935L4.17527 0.549354C4.42407 0.277942 4.84578 0.259606 5.11719 0.508401C5.3886 0.757196 5.40694 1.17891 5.15814 1.45032L1.9228 4.97979L5.47145 8.52843Z"
        fill="#666666"
      />
    </svg>
  );
};
